var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchants(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.223,
    height: 20.201,
    viewBox: "0 0 20.223 20.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20706",
    "data-name": "Path 20706",
    d: "M3.25,12.172v9.394A.435.435,0,0,0,3.684,22H20.31a.435.435,0,0,0,.435-.435V12.172a2.8,2.8,0,0,0,1.011-1.109,2.32,2.32,0,0,0,.054-1.946h0L18.955,2.27a.435.435,0,0,0-.4-.27H5.437a.435.435,0,0,0-.4.27L2.184,9.118a2.32,2.32,0,0,0,.054,1.946A2.8,2.8,0,0,0,3.25,12.172Zm8.314,8.959h-3.5v-5.74h3.5Zm4.374,0h-3.5v-5.74h3.5Zm3.937,0H16.809V14.957a.435.435,0,0,0-.435-.435H7.624a.435.435,0,0,0-.435.435v6.174H4.124V12.538A2.861,2.861,0,0,0,7.187,11.3,2.857,2.857,0,0,0,12,11.3a2.857,2.857,0,0,0,4.811,0,2.861,2.861,0,0,0,3.063,1.239ZM2.993,9.451,5.728,2.87h12.54L21,9.451a1.454,1.454,0,0,1-.026,1.22,1.972,1.972,0,0,1-3.729-.87.435.435,0,1,0-.87,0,1.97,1.97,0,0,1-3.937,0,.435.435,0,1,0-.87,0,1.97,1.97,0,0,1-3.937,0,.435.435,0,1,0-.87,0,1.972,1.972,0,0,1-3.729.87,1.454,1.454,0,0,1-.043-1.22Z",
    transform: "translate(-1.885 -1.9)",
    fill: "#363636",
    stroke: "#363636",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchants);
export default __webpack_public_path__ + "static/media/Merchants.fb77c55da57430581438a69d4d9d8741.svg";
export { ForwardRef as ReactComponent };